/* PASEO — À propos : ciel/soleil pilotés au scroll (reproduction fidèle du proto), tilt, carnet */
(function () {
  var html = document.documentElement;

  // ciel : matin -> coucher de soleil (dégradé fixe sur <html>)
  var TOP = [[252, 245, 234], [248, 232, 200], [242, 210, 160], [231, 176, 128]];
  var BOT = [[249, 236, 216], [244, 218, 176], [236, 190, 140], [208, 132, 92]];
  var SUN = [[255, 198, 112], [252, 172, 86], [244, 140, 70], [228, 106, 60]];
  function lp(a, b, t) { return [Math.round(a[0] + (b[0] - a[0]) * t), Math.round(a[1] + (b[1] - a[1]) * t), Math.round(a[2] + (b[2] - a[2]) * t)]; }
  function pick(arr, p) { var n = arr.length - 1; var s = Math.min(n - 1, Math.floor(p * n)); return lp(arr[s], arr[s + 1], (p * n) - s); }

  var ticking = false;
  function frame() {
    var max = html.scrollHeight - innerHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, (scrollY || html.scrollTop) / max)) : 0;
    var tp = pick(TOP, p), bt = pick(BOT, p), sc = pick(SUN, p);
    var sunY = 16 + p * 62;          // le soleil descend
    var sunR = 20 + p * 4;           // et grossit un peu
    var sunLayer = 'radial-gradient(circle ' + sunR + 'vw at 76% ' + sunY + '%,rgba(255,222,150,1) 0%,rgba(' + sc + ',.96) 20%,rgba(' + sc + ',.5) 44%,rgba(' + sc + ',0) 66%)';
    var skyLayer = 'linear-gradient(180deg,rgb(' + tp + ') 0%,rgb(' + bt + ') 100%)';
    // soleil + ciel = un seul fond fixe (rien ne peut le masquer)
    html.style.background = sunLayer + ',' + skyLayer;
    html.style.backgroundAttachment = 'fixed,fixed';
    ticking = false;
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  addEventListener('resize', frame);
  frame();

  /* tilt 3D des photos .float */
  if (matchMedia('(hover:hover)').matches) {
    document.querySelectorAll('.float').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'perspective(1000px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg) translateY(-5px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* carnet horizontal glissable */
  document.querySelectorAll('.carnet').forEach(function (r) {
    var dn = false, sx, sl;
    r.addEventListener('pointerdown', function (e) { dn = true; r.classList.add('g'); sx = e.pageX; sl = r.scrollLeft; });
    addEventListener('pointerup', function () { dn = false; r.classList.remove('g'); });
    r.addEventListener('pointermove', function (e) { if (!dn) return; e.preventDefault(); r.scrollLeft = sl - (e.pageX - sx) * 1.15; });
  });
})();
